<template>
  <li :id="msgItem.id">
    <div class="msgitem notice" v-if="showTime">
      <span>{{ handleDateTimeFormat(msgItem.send_time) }}</span>
    </div>
    <div v-if="msgItem.msgtype == 1" class="msgitem time">
      <span>{{ msgItem.msg }}</span>
    </div>
    <div v-else-if="msgItem.msgtype == 2" class="msgitem notice">
      <span>{{ msgItem.msg }}</span>
    </div>
    <!-- 3 文本消息 -->
    <textMessage v-if="msgItem.msgtype == 3" :msgItem="msgItem" :searchKeyWords="searchKeyWords" />
    <!--5 图片消息-->
    <imageMessage v-else-if="msgItem.msgtype == 5" :msgItem="msgItem" />
    <!-- 视频消息 -->
    <videoMessage v-else-if="msgItem.msgtype == 6" :msgItem="msgItem" />
    <!--7 笔记消息-->
    <noteMessage v-else-if="msgItem.msgtype == 7" :msgItem="msgItem" />
    <!--8 企业微信名片消息-->
    <cardMessage v-else-if="msgItem.msgtype == 8" :msgItem="msgItem" />
    <!--9 语音消息 -->
    <audioMessage v-else-if="msgItem.msgtype == 9" :msgItem="msgItem" />
    <div v-else>
      <div v-if="msgItem.msgtype != 1 && msgItem.msgtype != 2">
        【暂不支持此消息类型】，{{ noSupportTip }}
      </div>
    </div>
  </li>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, reactive, computed, inject } from "vue";
import imageMessage from "./imageMessage";
import textMessage from "./textMessage";
import cardMessage from "./cardMessage.vue";
import noteMessage from "./notemsg/noteMessage.vue";
import videoMessage from "./videomsg/index.vue";
import audioMessage from "./audiomsg/index.vue";
import { useStore } from "vuex";
import { PLAT_TYPE_MENU_TOOL } from "@/constants/plattypemenu-const";

export default {
  components: {
    textMessage,
    imageMessage,
    cardMessage,
    noteMessage,
    videoMessage,
    audioMessage,
  },
  props: {
    msgItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    upMsgTime: {
      type: String,
      default: () => {
        return "";
      },
    },
    searchKeyWords: { type: String },
  },
  setup(props) {
    let store = useStore();
    const momentUtil = inject("momentUtil");
    const data = reactive({
      active_item: 1,
    });

    //当前选中平台
    const chatingPlatId = computed(() => {
      return store.state.chat_store.chat_plat_id;
    });

    const noSupportTip = computed(() => {
      let paltId = store.state.chat_store.chat_plat_id;
      switch (paltId) {
        case PLAT_TYPE_MENU_TOOL.DOUYIN.value:
          return "请到抖音 App 端查看";
        case PLAT_TYPE_MENU_TOOL.XIAOHS.value:
          return "请到小红书 App 端查看";
        case PLAT_TYPE_MENU_TOOL.WEIXIN.value:
          return "请到微信客服 App 端查看";
        case PLAT_TYPE_MENU_TOOL.KUAISHOU.value:
          return "请到快手 App 端查看";
        default:
          return "";
      }
    });

    //   DOUYIN: {
    //   value: 1,
    //   desc: "抖音",
    //   icon: "icon-douyin",
    // },
    // XIAOHS: {
    //   value: 2,
    //   desc: "小红书",
    //   icon: "icon-xiaohongshu",
    //   colorClass:'m_color_e1'
    // },
    // WEIXIN: {
    //   value: 4,
    //   desc: "微信",
    //   icon: "icon-wechat1",
    //   colorClass: 'm_color_wechat'
    // },
    // WANGYE: {
    //   value: 3,
    //   desc: "网页",
    //   icon: "icon-zhinengwangyehuise",
    //   colorClass: 'm_color_webh5'
    // },
    // KUAISHOU: {
    //   value: 5,
    //   desc: "快手",
    //   icon: "icon-kuaishou11",
    //   colorClass: 'm_color_kuaishou',
    // },

    const showTime = computed(() => {
      if (!props.msgItem.send_time) {
        return false;
      }
      if (!props.upMsgTime) {
        return true;
      }
      let time1 = momentUtil.moment(props.msgItem.send_time, "YYYY-MM-DD HH:mm:ss");
      let time2 = momentUtil.moment(props.upMsgTime, "YYYY-MM-DD HH:mm:ss");
      let diff = time1.diff(time2, "seconds");
      if (Math.abs(diff) > 60) {
        return true;
      }
      return false;
    });

    const handleDateTimeFormat = (dateStr) => {
      if (!dateStr) {
        return "";
      }
      let timeMoment = momentUtil.moment(dateStr, "YYYY-MM-DD HH:mm:ss");
      if (timeMoment.isSame(momentUtil.moment(), "day")) {
        return timeMoment.format("HH:mm");
      } else {
        return dateStr;
      }

      // if(momentUtil.moment().diff(timeMoment,"day") >= 1){
      //   return dateStr
      // }
      // return timeMoment.fromNow();
    };

    onMounted(() => {});

    return {
      ...toRefs(data),
      chatingPlatId,
      noSupportTip,
      showTime,
      handleDateTimeFormat,
    };
  },
};
</script>

<style lang="scss" scoped></style>
